<script lang="ts">
	import { cn } from '@ui-lib/utils/utils';
	import { icons } from '../../lib/generated/icons';
	import { iconMap, type UnionIconValues } from '../../lib/icon';

	interface Props {
		myClass?: string;
		name: UnionIconValues;
		ariaHidden?: string;
		adjustPosition?: boolean;
		[key: string]: any;
	}

	let {
		myClass = 'w-4 h-4 md',
		name,
		ariaHidden = '',
		adjustPosition = false,
		...rest
	}: Props = $props();

	let combinedClass = $derived(
		cn(adjustPosition ? `${myClass} translate-y-[25%]` : myClass, rest.class)
	);

	const addFullSize = (svgStr: string) => {
		if (!svgStr) return svgStr;
		return svgStr.replace(/<svg([\s\S]*?)>/, `<svg class="w-full h-full" $1>`);
	};

	// @ts-expect-error Ignoring svg file matching
	let component = $derived(addFullSize(icons[name]) || iconMap[name]);
	// @ts-expect-error Ignoring svg file matching
	let isSvg = $derived(!!icons[name]);
</script>

{#if isSvg}
	<div {...rest} class={combinedClass}>
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html component}
	</div>
{:else if component}
	{@const SvelteComponent = component}
	<SvelteComponent role="img" aria-label={ariaHidden} class={combinedClass} {...rest} />
{/if}
